<ion-header>
  <ion-toolbar>
    <ion-title>Search on Brewfather</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss(null, null, null)">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
@if (externalApiSettings$ | async; as settings) {
  <ion-content class="ion-padding">
    <div class="ion-margin-bottom">
      <ion-text color="medium">
        <h6 style="margin-top:0;">Batch status</h6>
      </ion-text>
      <ion-chip button role="button" tabindex="0" data-testid="bf-status-chip" data-status="Planning" [outline]="batchStatus === 'Planning' ? false : true" [color]="batchStatus === 'Planning' ? 'success' : 'default'" (click)="getBatchesFromStatus(settings, 'Planning');" (keydown.enter)="getBatchesFromStatus(settings, 'Planning');">
        Planning
        @if(batchStatus === 'Planning'){
          <ion-icon name="checkmark-circle"></ion-icon>
        }
      </ion-chip>
      <ion-chip button role="button" tabindex="0" data-testid="bf-status-chip" data-status="Brewing" [outline]="batchStatus === 'Brewing' ? false : true" [color]="batchStatus === 'Brewing' ? 'success' : 'default'" (click)="getBatchesFromStatus(settings, 'Brewing');" (keydown.enter)="getBatchesFromStatus(settings, 'Brewing');">
        Brewing
        @if(batchStatus === 'Brewing'){
          <ion-icon name="checkmark-circle"></ion-icon>
        }
      </ion-chip>
      <ion-chip button role="button" tabindex="0" data-testid="bf-status-chip" data-status="Fermenting" [outline]="batchStatus === 'Fermenting' ? false : true" [color]="batchStatus === 'Fermenting' ? 'success' : 'default'" (click)="getBatchesFromStatus(settings, 'Fermenting');" (keydown.enter)="getBatchesFromStatus(settings, 'Fermenting');">
        Fermenting
        @if(batchStatus === 'Fermenting'){
          <ion-icon name="checkmark-circle"></ion-icon>
        }
      </ion-chip>
      <ion-chip button role="button" tabindex="0" data-testid="bf-status-chip" data-status="Conditioning" [outline]="batchStatus === 'Conditioning' ? false : true" [color]="batchStatus === 'Conditioning' ? 'success' : 'default'" (click)="getBatchesFromStatus(settings, 'Conditioning');" (keydown.enter)="getBatchesFromStatus(settings, 'Conditioning');">
        Conditioning
        @if(batchStatus === 'Conditioning'){
          <ion-icon name="checkmark-circle"></ion-icon>
        }
      </ion-chip>
      <ion-chip button role="button" tabindex="0" data-testid="bf-status-chip" data-status="Completed" [outline]="batchStatus === 'Completed' ? false : true" [color]="batchStatus === 'Completed' ? 'success' : 'default'" (click)="getBatchesFromStatus(settings, 'Completed');" (keydown.enter)="getBatchesFromStatus(settings, 'Completed');">
        Completed
        @if(batchStatus === 'Completed'){
          <ion-icon name="checkmark-circle"></ion-icon>
        }
      </ion-chip>
      <ion-chip button role="button" tabindex="0" data-testid="bf-status-chip" data-status="Archived" [outline]="batchStatus === 'Archived' ? false : true" [color]="batchStatus === 'Archived' ? 'success' : 'default'" (click)="getBatchesFromStatus(settings, 'Archived');" (keydown.enter)="getBatchesFromStatus(settings, 'Archived');">
        Archived
        @if(batchStatus === 'Archived'){
          <ion-icon name="checkmark-circle"></ion-icon>
        }
      </ion-chip>
    </div>
    <!-- <ion-item>
    <ion-label position="floating">Search</ion-label>
    <ion-input
      type="text"
      [(ngModel)]="searchName"
      #myInput
      (input)="filterItem(searchName)"
      placeholder="Search by name"
    ></ion-input> -->
    <!-- <ion-label>Batch Status</ion-label>
    <ion-select [value]="batchStatus"
      [(ngModel)]="batchStatus"
      (ionChange)="getBatches(0)"
      interface="popover"
      multiple="false" placeholder="Select">
      <ion-select-option value="Planning">Planning</ion-select-option>
      <ion-select-option value="Brewing">Brewing</ion-select-option>
      <ion-select-option value="Fermenting">Fermenting</ion-select-option>
      <ion-select-option value="Conditioning">Conditioning</ion-select-option>
      <ion-select-option value="Completed">Completed</ion-select-option>
      <ion-select-option value="Archived">Archived</ion-select-option>
    </ion-select> -->
  <!-- </ion-item> -->
  @if (beerStyles$ | async; as beerStyles) {
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        @if (batchStatus) {
          <ion-searchbar placeholder="Search by name" [(ngModel)]="searchName"
            #myInput data-testid="bf-searchbar"
          (ionInput)="filterItem(searchName)"></ion-searchbar>
        }
      </ion-card-content>
      <ion-card-content class="ion-no-padding ion-no-margin">
        @if (filteredItems.length > 0) {
          <div class="ion-padding">
            <ion-text color="medium">
              <h6 data-testid="bf-count">
                Count: {{ filteredItems.length }}
              </h6>
            </ion-text>
          </div>
        }
        <ion-list lines="full" class="ion-no-padding" data-testid="bf-results">
          @for (item of filteredItems; track item) {
            <ion-item
              button
              (click)="dismiss(beerStyles, settings, item);"
              >
              @if (item) {
                <ion-label
                  >{{item.name == 'Batch' ? item.recipe.name : item.name }}</ion-label
                  >
                }
              </ion-item>
            }
          </ion-list>
          @if (filteredItems.length == 0 && batchStatus) {
            <div class="ion-padding ion-text-center">
              <strong>No result</strong>
            </div>
          }
          @if (!batchStatus) {
            <div class="ion-padding ion-text-center">
              <strong>Please select batch status first</strong>
            </div>
          }
        </ion-card-content>
      </ion-card>
    }
  </ion-content>
}
